import BackofficeInterceptor from '../BackofficeInterceptor'

const api = new BackofficeInterceptor()

export default {
  checkIfEmailExists(email) {
    return api.get(`usuario/checkuserexists?email=${email}`)
  },
}
